<div id="pageHeader" style="margin: 0 1in">
    <span ngNonBindable class="control-label-text" [id]="controlId" [innerHTML]="componentData.label | safeHtml"></span>
</div>